"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _AccountSummaryBox = require("./AccountSummaryBox");
require("./AccountSummaryComponent.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('wallets-account-summary');
var SpotAccountSummaryComponent = function SpotAccountSummaryComponent(_ref) {
  var baseAsset = _ref.baseAsset,
    baseAssetDecimalPlaces = _ref.baseAssetDecimalPlaces,
    accountSummary = _ref.accountSummary,
    spotAccountId = _ref.spotAccountId,
    getAccountSummary = _ref.getAccountSummary,
    baseAssetProductId = _ref.baseAssetProductId;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    if (spotAccountId) {
      getAccountSummary(spotAccountId);
    }
  }, [spotAccountId, getAccountSummary, baseAssetProductId]);
  var formatValue = (0, _react.useCallback)(function (value) {
    return isNaN(value) || value === undefined ? value : (0, _numberFormatter.formatNumberToLocale)(value, baseAssetDecimalPlaces);
  }, [baseAssetDecimalPlaces]);
  var PnLPercentage = accountSummary.PnLPercentage || accountSummary.PnLPercentage === 0 ? "".concat(formatValue(accountSummary.PnLPercentage), "%") : '';
  var PnLValue = accountSummary.PnLValue || accountSummary.PnLValue === 0 ? "".concat(formatValue(accountSummary.PnLValue), " ").concat(baseAsset) : '';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('component', 'spot')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('left-section')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('column')
  }, /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('Total Balance ({{asset}})', {
      asset: baseAsset
    }),
    value: formatValue(accountSummary.TotalBalanceNotional)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('column')
  }, /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t('On Hold ({{asset}})', {
      asset: baseAsset
    }),
    value: formatValue(accountSummary.OnHoldAmountNotional)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('column')
  }, /*#__PURE__*/_react["default"].createElement(_AccountSummaryBox.AccountSummaryBox, {
    label: t("Today's P&L"),
    value: PnLPercentage
  }, PnLValue))));
};
var _default = exports["default"] = SpotAccountSummaryComponent;